package de.oevbs.kunde.kundenportal2.components

import de.oevbs.kosmos.ui.elements.button.Btn
import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.feedback.alert.alertBoxWithContent
import de.oevbs.kosmos.ui.icons.CustomIcons
import de.oevbs.kosmos.ui.icons.MaterialIconsFilled
import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import de.oevbs.kosmos.ui.icons.icon
import de.oevbs.kunde.kundenportal2.Pages
import de.oevbs.kunde.kundenportal2.activePage
import de.oevbs.kunde.kundenportal2.authentication.PortalAuthority
import de.oevbs.kunde.kundenportal2.authentication.PortalSession
import de.oevbs.kunde.kundenportal2.authentication.components.loginButton
import de.oevbs.kunde.kundenportal2.authentication.components.loginForm
import de.oevbs.kunde.kundenportal2.authentication.components.sessionButton
import de.oevbs.kunde.kundenportal2.authentication.hasAuthority
import de.oevbs.kunde.kundenportal2.navigation.components.breadcrumbs
import de.oevbs.kunde.kundenportal2.navigation.components.navbar
import de.oevbs.kunde.kundenportal2.navigation.visit
import de.oevbs.kunde.kundenportal2.services.authentication.partnerAuthenticationStart
import de.oevbs.kunde.kundenportal2.services.authentication.pinAuthenticationStart
import de.oevbs.kunde.kundenportal2.theRouter
import dev.fritz2.core.*
import dev.fritz2.headless.validation.Severity
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.map

fun RenderContext.appFrame() {
    val mobileSidebarVisibleStore = storeOf(false)
    theRouter.activePage.filterNotNull().map { false } handledBy mobileSidebarVisibleStore.update

    div("min-h-screen relative flex bg-white") {

        // Mobile-Sidebar
        div("fixed inset-0 flex z-40 md:hidden") {
            attr("role", true)
            attr("aria-modal", true)

            className(
                mobileSidebarVisibleStore.data.map { if (it) "visible" else "invisible" },
                initial = "invisible"
            )

            div("fixed inset-0 bg-gray-600 bg-opacity-75") {
                attr("aria-hidden", true)

                transition(
                    on = mobileSidebarVisibleStore.data,
                    enter = "transition-opacity ease-linear duration-300",
                    enterStart = "opacity-0",
                    enterEnd = "opacity-100",
                    leave = "transition-opacity ease-linear duration-300",
                    leaveStart = "opacity-100",
                    leaveEnd = "opacity-0"
                )
            }

            div("relative flex-1 flex flex-col max-w-xs w-full space-y-4 bg-primary-700") {
                transition(
                    on = mobileSidebarVisibleStore.data,
                    enter = "transition ease-in-out duration-300 transform",
                    enterStart = "-translate-x-full",
                    enterEnd = "translate-x-0",
                    leave = "transition ease-in-out duration-300 transform",
                    leaveStart = "translate-x-0",
                    leaveEnd = "-translate-x-full"
                )

                div("absolute top-0 right-0 -mr-12 pt-2") {
                    transition(
                        on = mobileSidebarVisibleStore.data,
                        enter = "ease-in-out duration-300",
                        enterStart = "opacity-0",
                        enterEnd = "opacity-100",
                        leave = "ease-in-out duration-300",
                        leaveStart = "opacity-100",
                        leaveEnd = "opacity-0"
                    )

                    div("ml-1 h-10 w-10") {
                        btn {
                            icon(MaterialIconsOutlined.close)
                            color(Btn.ColorScheme.Gray)
                            variant = Btn.Variant.Ghost

                            span("sr-only") { +"Menü schließen" }

                            clicks.map { false } handledBy mobileSidebarVisibleStore.update
                        }
                    }
                }

                sidebar()
            }
            div("flex-shrink-0 w-14") {
                attr("aria-hidden", true)
                // Dummy element to force sidebar to shrink to fit close icon
            }
        }

        // Desktop-Sidebar
        div("fixed hidden w-80 h-full bg-primary-700 md:flex md:flex-shrink-0 z-40") {
            sidebar()
        }

        // Top Bar
        div("fixed md:pl-80 top-0 z-20 flex h-16 bg-white shadow w-full") {
            div("flex-1 px-4 md:px-8 flex justify-between") {
                div("flex-grow flex flex-row items-center gap-4") {
                    div("md:hidden") {
                        btn {
                            icon(MaterialIconsFilled.menu)
                            variant = Btn.Variant.Ghost
                            clicks.map { true } handledBy mobileSidebarVisibleStore.update
                        }
                    }
                    theRouter.activePage.renderNotNull { page ->
                        breadcrumbs(page)
                    }
                }
                div("ml-4 flex items-center md:ml-6") {
                    combine(theRouter.activePage, PortalSession.isLoggedIn, ::Pair).renderIf({ (page, loggedIn) ->
                        !loggedIn && Pages.root != page
                    }) {
                        loginButton()
                    }
                    PortalSession.isLoggedIn.renderIf({ it }) {
                        sessionButton()
                    }
                }
            }
        }

        // Content
        main("mt-16 md:pl-80 flex-1 relative flex flex-col justify-between focus:outline-none") {
            div("grow vui-label-4") {
                renderContentBasedOnAuthenticationState()
            }

            div("w-full p-4 flex flex-row flex-wrap gap-x-4 gap-y-1 justify-center items-center text-sm text-gray-700") {
                a {
                    href("https://www.oeffentliche.de/content/oeffentliche/gesetzliche-regelungen/impressum/")
                    target("_blank")
                    +"Impressum"
                }
                a {
                    href("https://www.oeffentliche.de/content/oeffentliche/gesetzliche-regelungen/datenschutz/")
                    target("_blank")
                    +"Datenschutz"
                }
                span {
                    +"Made with ♡ in Braunschweig"
                }
            }
        }


        floatingContactButton()
    }
}

private fun RenderContext.sidebar() {
    div("w-full flex flex-col flex-grow gap-10 py-5 overflow-y-auto text-gray-100 leading-none") {
        button("px-5 flex flex-row justify-between items-center flex-shrink-0 px-4 text-gray-100") {
            h1("text-2xl font-extrabold") {
                +"Meine Öffentliche"
            }
            icon("w-8 h-8", icon = CustomIcons.oevbs_logo_colorless)
        }.clicks handledBy {
            Pages.root.visit()
        }

        // Entweder bei Entfernen des unten stehenden Bildes hier wieder das grow einfügen
        // oder das Div des Bildes mit grow drinlassen.
        div {/* div ("grow") { */
            navbar()
        }

        PortalSession.data.renderIf({ principal ->
            principal == null
        }) {
            div("flex grow items-start") {
                imageRoute(
                    "",
                    "Ein Foto von einer Frau, die ein Mobiltelefon hält. Der Text auf dem Bild sagt: Holen Sie sich Ihre digitale Kfz-Servicekarte - jetzt einloggen und loslegen!",
                    "images/other/VorLoginDigiCardAd.jpg"
                ) handledBy { Pages.serviceCarInsuranceDigiCard.visit() }
            }
            contactSection()
        }
    }
}

private fun RenderContext.contactSection() {
    div("px-5 flex flex-col gap-6") {
        +"Sie haben Fragen? Rufen Sie uns an:"

        div("flex flex-col items-center") {
            div {
                div("flex flex-row gap-2 items-center") {
                    icon("w-5 h-5", icon = MaterialIconsOutlined.calendar_clock)
                    +"Mo - Fr 08:00 - 18:00 Uhr"
                }
                a("flex flex-row gap-2 items-center") {
                    icon("w-5 h-5", icon = MaterialIconsOutlined.call)
                    +"0531 / 20 20"
                    href("tel:0531-20-20")
                }
            }
        }

        p("text-sm leading-relaxed") {
            span("block") {
                +"Sie kommen bei Registrierung, Vertragsverknüpfung oder Login nicht weiter?"
            }
            a("text-primary-200 underline") {
                +"Teilen Sie uns das mit!"
                href("https://www.oeffentliche.de/content/service/kundenportal/hilfe/")
                target("_blank")
            }
        }
    }
}

private fun RenderContext.renderContentBasedOnAuthenticationState() {
    // Rendert basierend auf dem Authentifizierungszustand des Nutzers entweder den Seiteninhalt,
    // Authentifizierungsformulare oder Fehlermeldungen.
    //
    // Die Logik wurde eins zu eins aus dem alten Kundenportal übernommen und wurde absichtlich nicht weiter refactored.
    // Bei zukünftigen Aufräumarbeiten ist dringend darauf zu achten, dass das Verhalten sich nicht ändert!
    combine(PortalSession.data, theRouter.route, theRouter.activePage, ::Triple).render { (principal, route, page) ->
        when {
            // Fall 0: Unbekannte Seite
            page == null -> pageNotFoundAlert(route ?: "unbekannt")

            // Fall 1: Der Nutzer hat die für die Route benötigte Rolle (oder es wird keine Rolle benötigt):
            hasAuthority(principal, page.roleForRoute) -> {
                page.content(this, page)
            }

            // Fall 2: Der Nutzer braucht eine Rolle, ist aber nicht eingeloggt
            principal == null -> loginForm()

            // Fall 3: Der User ist eingeloggt, aber nicht verknüpft.
            // AZ_SFA_KUPLA_PINAUTHED muss hier nicht mehr abgefragt werden, da es in Fall 1 enthalten
            // ist.
            !hasAuthority(principal, PortalAuthority.CrmAuthenticated) -> {
                partnerAuthenticationStart()
            }

            // Fall 4: User hat sich verknüpft, muss aber noch seine Identität per PIN-Brief
            // bestätigen oder eine seiner Mail-Adressen auswählen
            !hasAuthority(principal, PortalAuthority.PinAuthenticated) -> {
                pinAuthenticationStart()
            }

            else -> insufficientPermissionsAlert()
        }
    }
}

private fun RenderContext.floatingContactButton() {
    button(
        joinClasses(
            "group fixed bottom-6 right-6 w-14",
            "rounded-full bg-primary-600 shadow-sm p-4 font-semibold text-md text-white overflow-hidden",
            "transition-[width,padding] duration-300",
            "hover:w-32 hover:bg-primary-500 hover:px-4",
            "focus-visible:w-32 focus-visible:px-4 focus-visible:outline focus-visible:outline-2",
            "focus-visible:outline-offset-2 focus-visible:outline-primary-600"
        )
    ) {
        type("button")
        span(
            joinClasses(
                "absolute left-0 w-full whitespace-nowrap opacity-0",
                "transition-opacity duration-300",
                "group-hover:opacity-100 group-focus-visible:opacity-100"
            )
        ) {
            +"Kontakt"
        }
        icon(
            joinClasses(
                "h-6 w-6 transition-opacity duration-300",
                "group-hover:opacity-0 group-focus-visible:opacity-0",
            ),
            icon = MaterialIconsOutlined.chat_bubble
        )
    }.clicks handledBy {
        Pages.contactOverview.visit()
    }
}

private fun RenderContext.pageErrorAlert(title: String, description: String) {
    div("w-full h-full flex flex-col items-center") {
        div("w-full max-w-lg pt-4 md:pt-8") {
            alertBoxWithContent {
                severity = Severity.Error
                title(title)
                content = {
                    p("leading-relaxed") {
                        span("block") {
                            +description
                        }
                        button("text-start underline") {
                            +"Zur Startseite zurückkehren"
                        }.clicks handledBy {
                            Pages.root.visit()
                        }
                    }
                }
            }
        }
    }
}

private fun RenderContext.pageNotFoundAlert(href: String) =
    pageErrorAlert(
        title = "Seite nicht gefunden",
        description = """Die aufgerufene Seite '$href' konnte nicht gefunden werden."""
    )

private fun RenderContext.insufficientPermissionsAlert() =
    pageErrorAlert(
        title = "Zugriff verweigert",
        description = "Sie verfügen nicht über die erforderlichen Berechtigungen zum Zugriff auf diese Seite."
    )